module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "swipe"
  }, [_c('mt-swipe', {
    attrs: {
      "auto": 2000
    }
  }, [_c('mt-swipe-item', [_c('img', {
    attrs: {
      "src": "http://i0.hdslb.com/bfs/archive/98214e7feaf972248e8f408d6178b91bb70451b7.jpg"
    }
  })]), _vm._v(" "), _c('mt-swipe-item', [_c('img', {
    attrs: {
      "src": "http://i0.hdslb.com/bfs/archive/c6e8b040acffd6a7403795ea4141776071b1d901.jpg"
    }
  })]), _vm._v(" "), _c('mt-swipe-item', [_c('img', {
    attrs: {
      "src": "http://i0.hdslb.com/bfs/archive/9e630ace5bdd1ac947a3add9bf43db4b11cf49f6.jpg"
    }
  })]), _vm._v(" "), _c('mt-swipe-item', [_c('img', {
    attrs: {
      "src": "http://i0.hdslb.com/bfs/archive/a55e48a158d81ce665f56d6e894b4fd5ce3ed69d.jpg"
    }
  })]), _vm._v(" "), _c('mt-swipe-item', [_c('img', {
    attrs: {
      "src": "http://i0.hdslb.com/bfs/archive/1a5b75a23d0b9a0186969fdb7941e720eec44bab.jpg"
    }
  })])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48c7f3b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/swipe.vue
// module id = 107
// module chunks = 0